// extracted by mini-css-extract-plugin
module.exports = {"seo-footer":"SeoFooter_seo-footer__nPZwN","seo-footer__slide":"SeoFooter_seo-footer__slide__uX08c"};